// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDeliveryAddressRequestModel from '../../model/get-delivery-address-request-model';
import GetDeliveryAddressRequestDTO from '../dto/get-delivery-address-request-dto';
import dtoSchema from '../schemas/get-delivery-address-request-schema';

export default abstract class GetDeliveryAddressRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDeliveryAddressRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetDeliveryAddressRequestDTO>): GetDeliveryAddressRequestModel;
  static toModel(dto: DeepPartial<GetDeliveryAddressRequestDTO> | undefined | null): GetDeliveryAddressRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDeliveryAddressRequestDTO> | undefined | null): GetDeliveryAddressRequestModel | undefined {
    return dto ? new GetDeliveryAddressRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDeliveryAddressRequestModel> | GetDeliveryAddressRequestModel): GetDeliveryAddressRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetDeliveryAddressRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDeliveryAddressRequestModel, can not map to GetDeliveryAddressRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
